import { getBooleanField, getTextField } from '@lender/utils';
import dayjs from 'dayjs';
import { array, object } from 'yup';

import { COMMON_DATE_FORMAT } from 'constants/date';
import { DENIAL_REASON_VALUE_PROP_NAME, FieldTypesEnum } from 'constants/loanActionEditor';
import { transformNameInModelIntoFormName } from 'utils/formGenerator';

import {
  LOAN_ACTION_RICH_TEXT_MAX_LENGTH,
  LOAN_ACTION_RICH_TEXT_MAX_LENGTH_ERROR,
} from '../LoanInfoHeader.constants';

export const getUpdatedFieldsFromForm = ({
  form,
  loanActionFieldsMap,
  fields,
  denialReasonField,
}) => {
  const fieldsResults = fields.map(field => {
    const formFieldValue = form[transformNameInModelIntoFormName(field.fieldId)];
    const { type } = loanActionFieldsMap[field.fieldId];

    const getFieldValue = () => {
      if (type === FieldTypesEnum.SELECT) {
        return formFieldValue?.value;
      }

      if (type === FieldTypesEnum.MULTISELECT) {
        return formFieldValue?.map(({ value }) => value);
      }

      if (type === FieldTypesEnum.DATE) {
        return formFieldValue && dayjs(formFieldValue).format(COMMON_DATE_FORMAT);
      }

      return formFieldValue ?? '';
    };

    return { ...field, value: getFieldValue() };
  });

  if (denialReasonField) {
    fieldsResults.push({
      ...denialReasonField,
      [DENIAL_REASON_VALUE_PROP_NAME]:
        form.denialReasons?.map(({ value, borrowers = [] }) => ({
          id: value,
          selectedBorrowers: borrowers.reduce((acc, { id, value }) => {
            if (value) {
              acc.push(id);
            }

            return acc;
          }, []),
        })) ?? [],
    });
  }

  return fieldsResults;
};

export const getRichTextLoanActionFieldSchema = ({ isRequired }) =>
  getTextField({ isRequired }).max(
    LOAN_ACTION_RICH_TEXT_MAX_LENGTH,
    LOAN_ACTION_RICH_TEXT_MAX_LENGTH_ERROR,
  );

export const getDenialReasonSchemaShape = isRequiredField => ({
  denialReasons: array()
    .of(
      object().shape({
        value: getTextField(),
        name: getTextField(),
        borrowers: array()
          .of(
            object().shape({
              id: getTextField(),
              value: getBooleanField(),
            }),
          )
          .test({
            message: 'At least one borrower must be selected',
            test: borrowers => !borrowers || borrowers.some(({ value }) => value),
          }),
      }),
    )
    .test({
      message: 'Denial Reasons is required',
      test: denialReasonsArray => (isRequiredField ? denialReasonsArray?.length > 0 : true),
    }),
});
